import gql from 'graphql-tag';
export const GET_COUNTRIES = gql `
  query Country {
    countries {
      name
      code
      fiscalEntity
      companyIdentifier
      companyIdentifierSelfGrant
      currencies
      geoArea
      states {
        name
        code
      }
    }
  }
`;
//# sourceMappingURL=country.list.js.map